// Route Landing Pages
import { Home } from 'components/_views/Home/Home';

export const Routes = [
  { path: '/', component: Home, exact: true },
];
